import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./article.css";

export default function Article() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchPost() {
      try {
        const res = await fetch(`/api/posts/${id}`);
        const data = await res.json();
        setPost(data);
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    }

    fetchPost();
  }, [id]);

  if (loading) {
    return (
      <main className="article-page">
        <div className="article-loading">Loading article...</div>
      </main>
    );
  }

  if (!post) {
    return (
      <main className="article-page">
        <button className="back-button" onClick={() => navigate(-1)}>
          ← Go Back
        </button>
        <div className="article-empty">Post not found.</div>
      </main>
    );
  }

   return (
  <main className="article-page">
    <div className="article-container">
      <button className="back-button" onClick={() => navigate(-1)}>
        ← Back
      </button>

      <article className="article-card-full">
        <div
          className="article-cover"
          style={{
            backgroundImage: `linear-gradient(rgba(31,27,24,.08), rgba(31,27,24,.32)), url(${post.image})`,
          }}
        />

        <div className="article-body">
          <div className="article-meta">
            <span>{post.date}</span>
            <span>•</span>
            <span>By Nguyễn Ngọc Gia Hân</span>
          </div>

          <h1>{post.title}</h1>

          <div className="article-content">
            {post.content.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </div>
        </div>
      </article>
    </div>
  </main>
);
  
}
